export const ROLES = {
    SUPER_ADMIN: 'Super_Admin',
    ADMIN: 'admin',
    SALES_PERSON: 'sales_rep',
    REGION_SALES_HEAD: 'regional_sales_head',
    LAB: 'lab'
};

// Define which routes are accessible by which roles.
// This is the centralized configuration for your application's security.
export const roleConfig = {
    dashboard: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.REGION_SALES_HEAD,ROLES.SALES_PERSON],
    sales: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.REGION_SALES_HEAD, ROLES.SALES_PERSON],
    lab: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.LAB],
    management: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    about: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.REGION_SALES_HEAD, ROLES.SALES_PERSON, ROLES.LAB],

    // Granular permissions for the tabs within the Management page
    management_tabs: {
        city: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        hospital: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        doctors: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        phlebotomists: [ROLES.SUPER_ADMIN], // Only Super_Admin can manage phlebotomists
        users: [ROLES.SUPER_ADMIN], // Only Super_Admin can see this
        tests: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        pricing: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        performance: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        mappings: [ROLES.SUPER_ADMIN],
        emailMappings: [ROLES.SUPER_ADMIN],
        // passkey: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.REGION_SALES_HEAD, ROLES.SALES_PERSON, ROLES.LAB], // All roles can register passkey
        passkey: [ROLES.SUPER_ADMIN],
        salesAccess: [ROLES.SUPER_ADMIN],
    }
};
